import request from '@/axios'
import type { UserLoginType, AccessUserType } from './types'

/**
 * @description 모의 해킹 취약점 주석 처리 (2025.03.24)
 * 프론트에서 usrId, pwd를 넘기지 않고
 * 서버에서 로그인된 사용자 기준으로만 처리함
 */
interface MenuBodyType {
  // usrId: string | undefined
  // pwd: string | undefined
  langType: string
  isMobile: string
}

export interface PublicKeyDto {
  publicKeyExponent?: string
  publicKeyModulus?: string
}

export const loginApi = (data: UserLoginType): Promise<IResponse<AccessUserType>> => {
  return request.post({ url: '/v1/login/loginUser', data })
}

export const loginAuthApi = (data: UserLoginType): Promise<IResponse> => {
  return request.post({ url: '/v1/login', data })
}

export const loginLogApi = (data: UserLoginType): Promise<IResponse<AccessUserType>> => {
  return request.post({ url: '/v1/login/log', data })
}

export const loginOutApi = (): Promise<IResponse> => {
  return request.get({ url: '/v1/login/logout' })
}

export const getAdminRoleApi = (
  data: MenuBodyType
): Promise<IResponse<AppCustomRouteRecordRaw[]>> => {
  return request.post({ url: '/v1/menu/getmenu', data })
}

// export const getMenuByRole = (): Promise<IResponse<AppCustomRouteRecordRaw[]>> => {
//   return request.post({ url: '/v1/menu/getmenu' })
// }

export const getMyMenus = (): Promise<IResponse<string[]>> => {
  return request.get({ url: '/v1/menu/getMyMenus' })
}

export const putMyMenus = (data: string[]) => {
  return request.put({ url: '/v1/menu/putMyMenus', data })
}

export const getRsaPubKey = (): Promise<IResponse<PublicKeyDto>> => {
  return request.post({ url: '/v1/login/getRsaPub' })
}

export const updatePwd = (data = {}) => {
  return request.put({ url: '/v1/updatePwd', data })
}

export const getTestRoleApi = (data: MenuBodyType): Promise<IResponse<string[]>> => {
  return request.get({ url: '/mock/role/list2', data })
}
